import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function CognitoAiFileUploadCompletePane({
  fileName,
  uploadId,
  onClose,
}) {
  return (
    <Box sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4, textAlign: "center" }}>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <CheckCircleIcon sx={{ fontSize: 80, color: "success.main" }} />
        </Box>

        <Typography variant="h5" gutterBottom>
          Upload Successful!
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          Your file has been uploaded successfully.
        </Typography>

        <Paper
          elevation={0}
          sx={{ p: 2, backgroundColor: "#f5f5f5", mb: 3, mt: 3 }}
        >
          <Typography variant="body2" color="text.secondary">
            File Name
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {fileName}
          </Typography>

          {uploadId && (
            <>
              <Typography variant="body2" color="text.secondary">
                Upload ID
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "monospace",
                  wordBreak: "break-all",
                }}
              >
                {uploadId}
              </Typography>
            </>
          )}
        </Paper>

        <Button variant="contained" onClick={onClose} fullWidth size="large">
          Close
        </Button>
      </Paper>
    </Box>
  );
}
